import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  const services = [
    "Plafonnage",
    "Peinture Intérieure",
    "Cloisons Gyproc",
    "Pose de Sol",
    "Finitions Décoratives",
    "Rénovation Complète",
  ];

  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] py-20 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="block">
              <img 
                src="/images/logo.png" 
                alt="Perfect Team Renov" 
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed">
              {t("footer.description")}
            </p>
            <div className="text-white/40 text-sm space-y-1">
              <p>Perfect Team Renov SRL</p>
              <p>TVA: BE 0685.408.532</p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-['Cormorant_Garamond'] text-lg font-semibold mb-6">
              {t("footer.services")}
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-white/50 text-sm hover:text-[#B87333] transition-colors"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-['Cormorant_Garamond'] text-lg font-semibold mb-6">
              {t("footer.navigation")}
            </h4>
            <ul className="space-y-3">
              {[
                { label: t("nav.home"), path: "/" },
                { label: t("nav.services"), path: "/services" },
                { label: t("nav.projects"), path: "/projets" },
                { label: t("nav.quote"), path: "/devis" },
                { label: t("nav.contact"), path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/50 text-sm hover:text-[#B87333] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-['Cormorant_Garamond'] text-lg font-semibold mb-6">
              {t("footer.contact")}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#B87333] flex-shrink-0 mt-1" />
                <span className="text-white/50 text-sm">
                  Bergensesteenweg 24/8<br />
                  1600 Sint-Pieters-Leeuw
                </span>
              </li>
              <li>
                <a
                  href="tel:+32488467522"
                  className="flex items-center space-x-3 text-white/50 hover:text-[#B87333] transition-colors"
                >
                  <Phone size={18} className="text-[#B87333]" />
                  <span className="text-sm">+32 488 46 75 22</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@perfectteamrenov.be"
                  className="flex items-center space-x-3 text-white/50 hover:text-[#B87333] transition-colors"
                >
                  <Mail size={18} className="text-[#B87333]" />
                  <span className="text-sm">info@perfectteamrenov.be</span>
                </a>
              </li>
            </ul>

            {/* Service Area */}
            <div className="mt-8">
              <h5 className="text-white text-sm font-semibold mb-3">
                {t("footer.serviceArea")}
              </h5>
              <div className="flex items-center gap-2">
                <span className="text-sm px-4 py-2 bg-gradient-to-r from-[#B87333] to-[#CD7F32] text-white rounded-full font-medium">
                  Toute la Belgique
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} Perfect Team Renov SRL. {t("footer.rights")}
            </p>
            <p className="text-white/40 text-sm">
              Site créé par Daniel
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
